import React, { MouseEvent, RefObject, TouchEvent, useState, WheelEvent } from 'react'

export const useSwipe = (
  ref: RefObject<HTMLDivElement>,
  onScroll: (e: WheelEvent<HTMLDivElement> | TouchEvent<HTMLDivElement>) => void,
  premium = false,
) => {
  const [isDragging, setIsDragging] = useState(false)
  const [startX, setStartX] = useState(0)
  const [scrollLeft, setScrollLeft] = useState(0)

  const onMouseDown = (e: MouseEvent) => {
    if (!ref.current || !premium) {
      return
    }

    setIsDragging(true)
    setStartX(e.pageX - ref.current.offsetLeft)
    setScrollLeft(ref.current.scrollLeft)
    e.preventDefault()
  }

  const onMouseMove = (e: MouseEvent) => {
    if (!isDragging || !ref.current || !premium) {
      return
    }

    const x = e.pageX - ref.current.offsetLeft
    const koef = 2 // Множитель для скорости скролла
    const walk = (x - startX) * koef
    ref.current.scrollLeft = scrollLeft - walk

    const syntheticEvent = {
      ...e,
      target: ref.current,
    } as unknown as React.WheelEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>

    onScroll(syntheticEvent)
  }

  const onMouseUp = () => {
    setIsDragging(false)
  }

  const onMouseLeave = () => {
    setIsDragging(false)
  }

  return {
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave,
  }
}
